import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

type ValidationError = {
  type: 'placeholder' | 'invalid' | 'standalone-url';
  token: string;
  message: string;
  tooltip?: string;
};

type Props = {
  open: boolean;
  validationErrors: ValidationError[];
  onClose: (confirmed: boolean) => void;
};

export default function ValidationConfirmDialog({ open, validationErrors, onClose }: Props) {
  const handleCancel = () => {
    onClose(false);
  };

  const handleConfirm = () => {
    onClose(true);
  };

  return (
    <Dialog 
      open={open} 
      maxWidth="sm" 
      fullWidth
      onClose={handleCancel}
      sx={styles.dialog}
    >
      <DialogTitle sx={styles.dialogTitle}>
        <Box sx={styles.dialogHeader}>
          <WarningAmberIcon sx={styles.dialogIcon} />
          <Typography sx={styles.dialogTitleText}>
            Validation Warnings
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent sx={styles.dialogContent}>
        <Typography variant="body1" sx={styles.dialogText}>
          Your message contains validation warnings. Are you sure you want to send it anyway?
        </Typography>
      </DialogContent>
      
      <DialogActions sx={styles.dialogActions}>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="primary"
          sx={styles.confirmButton}
        >
          Send Now
        </Button>
        <Button 
          onClick={handleCancel} 
          color="inherit"
          variant="text"
          sx={styles.cancelButton}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const styles = {
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '12px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
    }
  },
  dialogTitle: {
    paddingBottom: '12px',
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  dialogIcon: {
    color: '#ff9800',
    fontSize: '28px'
  },
  dialogTitleText: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#333'
  },
  dialogContent: {
    paddingTop: '8px',
    paddingBottom: '20px'
  },
  dialogText: {
    marginBottom: 0,
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#555'
  },
  dialogActions: {
    padding: '16px 24px',
    gap: '12px',
    justifyContent: 'flex-end'
  },
  confirmButton: {
    minWidth: '120px',
    textTransform: 'none',
    fontWeight: 600,
    borderRadius: '25px',
    paddingX: '24px',
    paddingY: '8px'
  },
  cancelButton: {
    minWidth: '80px',
    textTransform: 'none',
    fontWeight: 500,
    color: '#666'
  }
};
